import React from 'react';
import { t } from '../../../../../i18n';
import UserAvatar from '../../../../components/user-avatar';
import './styles.scss';

const SummaryBlock = ({
  userName,
  userEmail,
  userPhotoUrl,
  completedCoursesTotal,
  activeCoursesTotal,
  trainingHoursTotal,
}) => {
  return (
    <div className="profile-screen__summary-wrapper">
      <div className="profile-screen__summary-block">
        <div className="profile-screen__user-information-wrapper">
          <div className="profile-screen__user-avatar-wrapper">
            <UserAvatar photoUrl={userPhotoUrl} userName={userName} className="profile-screen__user-avatar" />
          </div>
          <div>
            <b>{userName}</b>
            <p>{userEmail}</p>
          </div>
        </div>
        <div className="profile-screen__characteristics-wrapper">
          <div className="profile-screen__characteristic-block">
            <b>{completedCoursesTotal}</b>
            <p>{t('DIGITAL_COURSES.PROFILE_SCREEN.COMPLETED_COURSES')}</p>
          </div>
          <div className="profile-screen__characteristic-block">
            <b>{activeCoursesTotal}</b>
            <p>{t('DIGITAL_COURSES.PROFILE_SCREEN.ACTIVE_COURSES')}</p>
          </div>
          <div className="profile-screen__characteristic-block">
            <b>{trainingHoursTotal}</b>
            <p>{t('DIGITAL_COURSES.PROFILE_SCREEN.TRAINING_HOURS')}</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SummaryBlock;
